var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-xs-center"},[_c('div',{staticClass:"logo"},[_c('StAndrewsLogo')],1),_c('h1',[_vm._v("Page not found.")]),_c('v-btn',{on:{"click":_vm.goToDashboard}},[_vm._v("Go back home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }